<template>
  <div>
    <page-header title="Dodaj lektora" />
    <form-wrapper
      ref="form"
      :service="Lecturer"
      :formComponent="InnerForm"
      :form.sync="form"
      :errors.sync="errors"
      :getSuccessRoute="getSuccessRoute"
      class="c-box"
      success-message="Lektor dodany"
    />
  </div>
</template>

<script>
import { Lecturer } from '@/api'
import InnerForm from '@/components/forms/LecturerForm'

export default {
  data() {
    return {
      InnerForm,
      Lecturer,
      form: {
        receive_email_notifications: true,
        languages: [{}]
      },
      errors: {}
    }
  },
  methods: {
    getSuccessRoute: res => ({
      path: `/admin/lektorzy/szczegoly/${res.data.id}/edytuj/`
    })
  }
}
</script>
